import { api } from "./api";
import { useStore } from "./store";

/**
 * Het gesprek met deze collega openen, en het aanmaken als het nog niet bestaat.
 *
 * Stond eerst alleen in Sidebar, waar het aan de Online-lijst hing. Nu de
 * zoekbalk ook mensen kan vinden - inclusief wie offline is - moeten beide
 * dezelfde weg lopen, anders krijg je twee manieren om een gesprek te beginnen
 * die net iets anders doen.
 *
 * Een verborgen gesprek halen we hier bewust NIET terug. Dat gebeurt vanzelf
 * zodra er weer een bericht in staat (zie de "automatisch terughalen"-uitleg in
 * Sidebar): openen is nog geen reden om iets terug te zetten wat je hebt
 * weggeklikt.
 */
export async function vindOfMaakDm(anderId: number): Promise<number> {
  const { conversations, me, upsertConversation } = useStore.getState();

  for (const c of Object.values(conversations)) {
    if (c.kind !== "dm") continue;
    if (c.member_ids.includes(anderId) && (me === null || c.member_ids.includes(me.id))) {
      return c.id;
    }
  }

  const { conversation } = await api.createConversation({
    kind: "dm",
    other_user_id: anderId,
  });
  upsertConversation(conversation);
  return conversation.id;
}
